import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import PreviewEventModal from '@/components/Admin/Tasks/PreviewEventModal';
import ComponentErrorBoundary from '@/Layouts/ComponentErrorBoundary';
import { fetchWrapper } from '@/_helpers';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';

const Component = React.memo(({ taskID, task, onClose = () => {}, setIsBusy = () => {} }) => {
    const location = useLocation();
    const [taskData, setTaskData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const getTaskIdFromURL = () => {
        const searchParams = new URLSearchParams(location.search);
        return searchParams.get('task');
    };
    const fetchTaskData = async (taskId) => {
        if (task && task?.externalEvent) {
            setTaskData(task);
            return setShowModal(true);
        }
        if (!taskId) return;

        setLoading(true);
        setIsBusy(true);
        try {
            const response = await fetchWrapper.get(`task/${taskId}`);
            setTaskData(response);
            setShowModal(true);
        } catch (err) {
            console.error('Failed to fetch task:', err);
            if (err?.name === 'AbortError') return;
            toast.error(err?.message || 'Failed to fetch event');
            setShowModal(false);
            onClose();
        } finally {
            setLoading(false);
            setIsBusy(false);
        }
    };

    const handleUpdateTask = async (taskId, updatedFields = null) => {
        if (updatedFields) {
            setTaskData((prev) => (prev ? { ...prev, ...updatedFields } : prev));
        }
        await fetchTaskData(taskId);
    };

    useEffect(() => {
        const taskId = taskID || getTaskIdFromURL();
        if (taskId) {
            fetchTaskData(taskId);
        } else {
            setShowModal(false);
            setTaskData(null);
        }
    }, [location.search, location.pathname, taskID]);

    // Close handler
    const handleClose = () => {
        setShowModal(false);
        setTaskData(null);
        const searchParams = new URLSearchParams(location.search);
        searchParams.delete('task');
        const newSearch = searchParams.toString();
        const newUrl = `${location.pathname}${newSearch ? `?${newSearch}` : ''}`;
        window.history.replaceState({}, '', newUrl);
        onClose();
    };

    // if (loading && !taskID) {
    //     return (
    //         <div className="d-flex justify-content-center p-4">
    //             <div className="spinner-border" role="status">
    //                 <span className="sr-only">Loading event...</span>
    //             </div>
    //         </div>
    //     );
    // }
    if (loading && !taskData)
        return (
            <Modal
                show={true}
                style={{
                    minHeight: '150px',
                }}
                centered
            >
                <Modal.Body>
                    <div className="d-flex justify-content-center p-4">
                        <div className="spinner-border" role="status">
                            <span className="sr-only">Loading event...</span>
                        </div>
                        <span className="ml-2">Please wait...</span>
                    </div>
                </Modal.Body>
            </Modal>
        );

    // if (error && !taskID) {
    //     return (
    //         <div className="alert alert-danger m-3" role="alert">
    //             {error}
    //         </div>
    //     );
    // }

    return (
        <>
            {showModal && taskData && (
                <PreviewEventModal data={taskData} handleClose={handleClose} handleUpdateTask={handleUpdateTask} />
            )}
        </>
    );
});

const mapStateToProps = (state) => ({
    currUser: state.user.user,
});

const EventModalFromURL = (props) => (
    <ComponentErrorBoundary componentErrorMessage={props?.componentErrorMessage}>
        <Component {...props} />
    </ComponentErrorBoundary>
);

export default connect(mapStateToProps, {})(EventModalFromURL);
